import { createContext, useContext } from "react";

const GenericDrawerContext = createContext({ close: () => { } })

export const useGenericDrawer = () => { return useContext(GenericDrawerContext) }

export default GenericDrawerContext;